import React from 'react';
import "./Section2.css";
import weddingss from "../images/cuisine.jpg";

const Section2 = () => {
  return (
    <div className="meet-container">
      <div className="content-section">
        <div className="text-section" data-aos="fade-down">
          <h1>Experience Authentic Indian Cuisine</h1>
          <h2>Sri Krishnaa's – A Taste of Tradition</h2>
          <p>
            At Sri Krishnaa's, located in Liverpool, we bring the vibrant and diverse flavors of India straight to your table. Our passion for authenticity and tradition shines through every dish, crafted by our expert chefs to celebrate India's rich culinary heritage.
          </p>
          <p>
            Whether you’re craving a cozy night in with our online ordering service, planning a quick and flavorful takeaway, or hosting an unforgettable event with our bespoke catering, Sri Krishnaa's has you covered. From classic curries to freshly baked naan and regional specialties, every bite promises a journey to the heart of India.
          </p>
          <p>
            Indulge in the flavors of India anytime, anywhere – Sri Krishnaa's is here to make every meal special!
          </p>
        </div>

        <div className="image-section">
          <img src={weddingss} alt="Event planning" className="event-image" />
        </div>
      </div>
    </div>
  );
};

export default Section2;
